import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgTaxIcon = (props) => /* @__PURE__ */ _jsxs("svg", {
	fill: "none",
	strokeLinecap: "round",
	strokeLinejoin: "round",
	strokeWidth: 1.5,
	stroke: "currentColor",
	viewBox: "0 0 16 16",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", { d: "M14.25 10.5C14 11.25 13.3399 11.75 12.5 11.75C11 11.75 10.25 10 10.25 8C10.25 6 11 4.25 12.5 4.25C13.3399 4.25 14 4.75 14.25 5.5M9.25 6.75H11.75M9.25 9.25H11.75" }),
		/* @__PURE__ */ _jsx("circle", {
			cx: 6,
			cy: 10.75,
			r: .5
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 2.25,
			cy: 5.25,
			r: .5
		}),
		/* @__PURE__ */ _jsx("path", { d: "M2 11L6 5" })
	]
});
export default SvgTaxIcon;
